import data from './countryData';

type Country = {
  label: string;
  code?: string;
};
let countryList = data;
if (process.env.REACT_APP_COUNTRY_SELECTOR_BLACKLIST) {
  let payload = [];
  try {
    const blackList = JSON.parse(process.env.REACT_APP_COUNTRY_SELECTOR_BLACKLIST);
    payload = countryList.filter((country) => {
      if (!blackList.includes(country.countryName)) {
        return country;
      }
      return null;
    });
    countryList = payload;
  } catch (error) {
    console.log(error);
  }
}

export const getAllCountries = () => {
  let payload = [];
  for (const country of countryList) {
    payload.push({
      label: country.countryName,
      code: country.countryShortCode,
    });
  }
  return payload;
};

export const getCountryByCode = (code: string) => {
  for (const country of countryList) {
    if (country.countryShortCode === code) {
      return {
        label: country.countryName,
        code: country.countryShortCode,
      };
    }
  }
  return null;
};

export const getRegionsByCountryCode = (code: string) => {
  for (const country of countryList) {
    if (country.countryShortCode === code) {
      return [...country.regions];
    }
  }
  return [];
};

export const getRegionByCode = (code: string) => {
  let allRegions: Country[] = [];
  for (const country of countryList) {
    allRegions = [...allRegions, ...country.regions];
  }
  let payload = allRegions.filter((region) => region.code === code)[0];

  return payload;
};
